
import React, { useState, useEffect, useCallback } from 'react'
import { Row, Col, Card, Button, Table, Tag, Breadcrumb, notification, Result, Modal, message, Radio, Space } from 'antd';
import _ from "lodash";
import useMclAuth from '../../hooks/useMclAuth';
import useAuth from '../../hooks/useAuth';
import { EditOutlined } from '@ant-design/icons';
import { Url, SubscriptionToColor, SubscriptionToStr, Roles, Subscription } from '../../constants/Global';
import { resolveOnChange } from 'antd/lib/input/Input';
import { AssignModal } from "../../components/SConciergeComponents"

const openNotification = ({ message, status, title, subTitle }) => {
    // console.log(message, title, status, subTitle)
    notification.open({
        message: message,
        description:
            <Result
                status={status}
                title={title}
                subTitle={subTitle}
            /* extra={<Button type="primary">Back Home</Button>}*/
            />
    });
};


const PartnersTable = ({data}) => {

  // const dataSource = [
  //     {
  //       id: "67e00d76d4071048e8439847",
  //       name: "jo men",
  //       position:"post",
  //       email: "user@test.com",
  //       phone: "408-555-5555",
  //       company: "compname",
  //       website: "https://test.com",
  //       product_service: "my product and service",
  //       partner_type: "Joint Marketing",
  //       message: "whatever message",
  //       createdAt: "2025-03-23T13:32:38.463Z",
  //       updatedAt: "2025-03-23T13:32:38.463Z",
  //     }
  //   ]

    const columns = [
      {
        title: 'Company',
        dataIndex: 'company',
        key: 'company',
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Position',
        dataIndex: 'position',
        key: 'position',
      },
      {
        title: 'Website',
        dataIndex: 'website',
        key: 'website',
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: 'Phone',
        dataIndex: 'phone',
        key: 'phone',
      },
      {
        title: 'Product/Service',
        dataIndex: 'product_service',
        key: 'product_service',
      },
      {
        title: 'Type',
        dataIndex: 'partner_type',
        key: 'partner_type',
      },
      {
        title: 'Message',
        dataIndex: 'message',
        key: 'message',
      },
      {
        title: 'Date Created',
        dataIndex: 'createdAtFmt',
        key: 'createdAt',
      },
    ];
    
    return (
        <Table
            columns={columns}
            dataSource={data}
        />
    )
} 

const Partnerships = ({ setPage }) => {

    const mclAuth = useMclAuth()
    const { auth } = useAuth()

    const [inquiries, setInquiries] = useState([])

    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState('')

    useEffect(() => {
        // Get clients
        mclAuth.get(Url.SUPER_CONCIERGES.concat('/', auth?.id,'/partnerships'))
            .then(res => {
                if (_.isArray(res.data)) {
                    const inquiriesData = [...res.data.map((inquiry) => {
                        inquiry.createdAtFmt = new Date(inquiry.createdAt).toLocaleString();
                        return inquiry;
                    })];
                    setInquiries(inquiriesData);
                }
                // console.log(res.data)
                setIsLoading(false)
            })
            .catch(error => {
                openNotification({ message: error.message, status: "500", title: "500", subTitle: "Failed to retrieve partnership inquiries" })
                setError(error.message)
                setIsLoading(false)
            })
    }, [auth.id, mclAuth])


    const homeBreadCrumbOnClick = (e) => {
        e.preventDefault();
        setPage("0")
    };

    const clientBreadCrumbOnClick = (e) => {
        e.preventDefault();
    };

    return (
        <div>
            <Row>
                <Col xs={24}>
                    <Breadcrumb separator=">" className="text-h6">
                        <Breadcrumb.Item>
                            <a href="#" onClick={homeBreadCrumbOnClick}>Home</a>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <a href="#" onClick={clientBreadCrumbOnClick}>Partnerships</a>
                        </Breadcrumb.Item>
                    </Breadcrumb>
                </Col>
            </Row>
            {
                <Card
                    className="mt-4"
                >
                    <PartnersTable
                        data={inquiries}
                    />
                </Card>
            }
        </div>
    )
}

export default Partnerships;